import React from 'react';
import './Declines.scss';

const Declines = ({ show, errors }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={'declines'}>
      <span className={'declines--title'}>Warning!</span>
      <ul>
        {errors.map((error) => {
          const reason = error?.reason ?? error;
          return <li>{reason}</li>;
        })}
      </ul>
    </div>
  );
};

export default Declines;
